const menus = [
    { id: 1, name: 'Home', linkmenu: '/' },
    { id: 2, name: 'Who We Are', linkmenu: '/about-v1' },
    { id: 3, name: 'What We Do', linkmenu: '/services-v1' },
    { id: 4, name: 'Resources', linkmenu: '/blog' },
    { id: 5, name: 'Talk to Us', linkmenu: '/contact-v1' }
]

export default menus;
